<div class="tags">
  <div class="new-dish-label">
    {{ 'MENU.DISHES.NEW.TAGS' | translate }}
  </div>
  <div class="tags-right">
    <mat-chip-list class="tags-chip-list" aria-label="Tags selection">
      <mat-chip *ngFor="let tagId of tagIdSet"
                [removable]="true"
                (click)="onOpenTag(tagId)">
        {{ getTagName(tagId) }}
        <button
          matChipRemove
          *ngIf="allowOverrides && isManuallyCreated(tagId)"
          (click)="onDeleteTag(tagId)">
          <mat-icon>delete</mat-icon>
        </button>
        <button
          *ngIf="allowOverrides"
          matChipRemove
          (click)="onRemoveTag(tagId)">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-list>

    <div *ngIf="allowOverrides" >
      <mat-form-field>
        <mat-select placeholder="{{ 'MENU.DISHES.NEW.TAG_NEW_NAME' | translate }}">
          <mat-option *ngFor="let tag of tagDtos">
            <div class="option-container">
              <p class="item1" (click)="onTagPicked(tag?.id)">
                {{ tag?.name }}
              </p>
              <p class="item2">
                <button *ngIf="allowOverrides && isManuallyCreated(tag.id)" (click)="onDeleteTag(tag.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              </p>
              <p class="item3">
                <button *ngIf="allowOverrides" (click)="onOpenTag(tag.id)">
                  <mat-icon>edit</mat-icon>
                </button>
              </p>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-icon
        *ngIf="allowOverrides"
        mat-icon-button
        matTooltip="{{'MENU.DISHES.NEW.ADD' | translate}}"
        class="size-scale-edit-button"
        (click)="onOpenTag()">add_box
      </mat-icon>
    </div>
  </div>
</div>
